function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { isSafariDesktop, isWebOsVeryLowPoweredDevice } from '../../utils/device-type';
import { AudioFormat } from '../../core/player/audio-format';
import { StreamingProtocol } from '../../core/player/playout-data';
import { PlayerType } from '../../core/player/player-type';
import { DEFAULT_VIDEO_FORMAT, VideoColourSpace } from '../../core/player/video-format';
import { mseBrowserCapabilities } from '../../device/browser/mse-capabilities';
import { mseProsperoCapabilities } from '../../device/prospero/mse-capabilities';
import { mseOneSdkCapabilities } from '../../device/onesdk/mse-capabilities';
import { mseTizenCapabilities } from '../../device/tizen/mse-capabilities';
import { mseUwpCapabilities } from '../../device/uwp/mse-capabilities';
import { mseVidaaCapabilities } from '../../device/vidaa/mse-capabilities';
import { mseVizioCapabilities } from '../../device/vizio/mse-capabilities';
import { mseWebOsCapabilities } from '../../device/webos/mse-capabilities';
import { mseMultiChoiceRdkCapabilities } from '../../device/multichoice-rdk/mse-capabilities';
import { mseQuestCapabilities } from '../../device/meta-quest/mse-capabilities';
import { mseNetgemCapabilities } from '../../device/netgem/mse-capabilities';
import { mseZenterioCapabilities } from '../../device/zenterio/mse-capabilities';
import { mseWinUI2Capabilities } from '../../device/winui2/mse-capabilities';
import { loadShaka } from './shaka-loader';
import { ShakaPlayerEngine } from './shaka-player-engine';
import { ShakaPlayerPrecursorEngine } from './shaka-player-precursor-engine';
import { isVersionCompliant, MINIMUM_VERSION_FOR_CODEC_SWITCHING, MINIMUM_VERSION_FOR_FULL_EVENT } from './shaka-version-utils';
import { getWidevineSecurity } from '../../utils/widevine-utils';
import { mseKpnCapabilities } from '../../device/kpn/mse-capabilities';
import { PsfParser } from './psf/psf-parser';
import { mseKeplerCapabilities } from '../../device/kepler/mse-capabilities';
export var ShakaPlayerEngineFactory = /*#__PURE__*/ function() {
    "use strict";
    function ShakaPlayerEngineFactory(config, device, debugConfig, drmConfig, shakaPropositionPlayerConfig, propositionThumbnailsConfig, propositionHighFramerateValue) {
        _class_call_check(this, ShakaPlayerEngineFactory);
        var _this_capabilityHelper_getSupportedAudioCodecs, _this_capabilityHelper, _this_capabilityHelper_getHdcpCompliance, _this_capabilityHelper_listenToHdcpComplianceChanges, _this_capabilityHelper_initialiseDrmKeys, _this_capabilityHelper1;
        _define_property(this, "config", void 0);
        _define_property(this, "device", void 0);
        _define_property(this, "debugConfig", void 0);
        _define_property(this, "drmConfig", void 0);
        _define_property(this, "shakaPropositionPlayerConfig", void 0);
        _define_property(this, "propositionThumbnailsConfig", void 0);
        _define_property(this, "propositionHighFramerateValue", void 0);
        _define_property(this, "type", void 0);
        _define_property(this, "playerVersion", void 0);
        _define_property(this, "capabilities", void 0);
        _define_property(this, "capabilityHelper", void 0);
        _define_property(this, "isSafari", void 0);
        this.config = config;
        this.device = device;
        this.debugConfig = debugConfig;
        this.drmConfig = drmConfig;
        this.shakaPropositionPlayerConfig = shakaPropositionPlayerConfig;
        this.propositionThumbnailsConfig = propositionThumbnailsConfig;
        this.propositionHighFramerateValue = propositionHighFramerateValue;
        this.type = PlayerType.Shaka;
        this.playerVersion = 'unknown';
        this.setCapabilityHelper();
        this.isSafari = isSafariDesktop(device.deviceInfo, device.type);
        this.capabilities = {
            canSetPlayerBitrateLimits: !this.isSafari,
            canSetMidStreamPlayerBitrateLimits: !this.isSafari,
            getPlayoutRect: true,
            setPlayoutRect: true,
            preconstructItems: true,
            preloadItems: true,
            hasLicensingSigning: true,
            isLinearScrubbingSupported: true,
            isDvrWindowNativelyHandled: false,
            hasNativeLiveWindowEvent: false,
            hasSeekingStateSupport: true,
            hasPrefetchSupport: true,
            forcesLiveWindowRecoveryWhilePaused: this.isSafari,
            canSeekByDate: true,
            canEmitFramerate: true,
            supportedAudioFormats: this.capabilityHelper.getSupportedAudioFormats(device),
            supportsCappingByResolution: true,
            hasMultiplePlayerVersions: true,
            emitsBulkTimedMetadata: true,
            supportedAudioCodecs: (_this_capabilityHelper_getSupportedAudioCodecs = (_this_capabilityHelper = this.capabilityHelper).getSupportedAudioCodecs) === null || _this_capabilityHelper_getSupportedAudioCodecs === void 0 ? void 0 : _this_capabilityHelper_getSupportedAudioCodecs.call(_this_capabilityHelper),
            supportsVideoElement: !this.isSafari,
            // Safari does not play nice with the Video Element Event track
            hdcpCompliance: (_this_capabilityHelper_getHdcpCompliance = this.capabilityHelper.getHdcpCompliance) === null || _this_capabilityHelper_getHdcpCompliance === void 0 ? void 0 : _this_capabilityHelper_getHdcpCompliance.bind(this),
            listenToHdcpComplianceChanges: (_this_capabilityHelper_listenToHdcpComplianceChanges = this.capabilityHelper.listenToHdcpComplianceChanges) === null || _this_capabilityHelper_listenToHdcpComplianceChanges === void 0 ? void 0 : _this_capabilityHelper_listenToHdcpComplianceChanges.bind(this)
        };
        this.overrideWebOS30Capabilities(device);
        (_this_capabilityHelper_initialiseDrmKeys = (_this_capabilityHelper1 = this.capabilityHelper).initialiseDrmKeys) === null || _this_capabilityHelper_initialiseDrmKeys === void 0 ? void 0 : _this_capabilityHelper_initialiseDrmKeys.call(_this_capabilityHelper1, device, self);
    }
    _create_class(ShakaPlayerEngineFactory, [
        {
            key: "overrideWebOS30Capabilities",
            value: function overrideWebOS30Capabilities(device) {
                if (device.type === DeviceType.WebOS && isWebOsVeryLowPoweredDevice(device.deviceInfo)) {
                    this.capabilities.maxBitrate = 3200000;
                    this.capabilities.isLinearScrubbingSupported = false;
                }
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_capabilityHelper_getPreloadSupport, _this_capabilityHelper, _this_config, _this_config1, _this_config2, _this_config3, _this_shakaPropositionPlayerConfig, _this_capabilityHelper_shouldUseXhr, _this_capabilityHelper1, _this_capabilityHelper_endOfStreamSeekTolerances, _this_capabilityHelper2, _ref, preconstructItems, preloadItems, hasPrefetchSupport, preloadBufferTimeSecs, _i, _iter, protocol, _, widevineSecurity, versionCompliant;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ref = ((_this_capabilityHelper_getPreloadSupport = (_this_capabilityHelper = _this.capabilityHelper).getPreloadSupport) === null || _this_capabilityHelper_getPreloadSupport === void 0 ? void 0 : _this_capabilityHelper_getPreloadSupport.call(_this_capabilityHelper, _this.device)) || {
                                    preconstructItems: true,
                                    preloadItems: true,
                                    hasPrefetchSupport: false,
                                    preloadBufferTimeSecs: 10
                                }, preconstructItems = _ref.preconstructItems, preloadItems = _ref.preloadItems, hasPrefetchSupport = _ref.hasPrefetchSupport, preloadBufferTimeSecs = _ref.preloadBufferTimeSecs;
                                return [
                                    4,
                                    loadShaka({
                                        shakaPlayerVersion: (_this_config = _this.config) === null || _this_config === void 0 ? void 0 : _this_config.shakaPlayerVersion,
                                        useMuxJS: (_this_config1 = _this.config) === null || _this_config1 === void 0 ? void 0 : _this_config1.useMuxJS,
                                        esVersion: (_this_config2 = _this.config) === null || _this_config2 === void 0 ? void 0 : _this_config2.esVersion,
                                        useDebug: (_this_config3 = _this.config) === null || _this_config3 === void 0 ? void 0 : _this_config3.useDebug,
                                        device: _this.device,
                                        subtitlesFormat: (_this_shakaPropositionPlayerConfig = _this.shakaPropositionPlayerConfig) === null || _this_shakaPropositionPlayerConfig === void 0 ? void 0 : _this_shakaPropositionPlayerConfig.subtitlesFormat
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _this.playerVersion = shaka.Player.version;
                                // Some devices (i.e. Netgem) although they have Fetch API support, it's not as performant as good old XHR.
                                // See https://github.com/NBCUDTC/shaka-player/pull/241
                                if ((_this_capabilityHelper_shouldUseXhr = (_this_capabilityHelper1 = _this.capabilityHelper).shouldUseXhr) === null || _this_capabilityHelper_shouldUseXhr === void 0 ? void 0 : _this_capabilityHelper_shouldUseXhr.call(_this_capabilityHelper1, _this.device)) {
                                    for(_i = 0, _iter = [
                                        'http',
                                        'https',
                                        'blob'
                                    ]; _i < _iter.length; _i++){
                                        protocol = _iter[_i];
                                        shaka.net.NetworkingEngine.registerScheme(protocol, shaka.net.HttpXHRPlugin.parse, shaka.net.NetworkingEngine.PluginPriority.APPLICATION, /* progressSupport= */ true);
                                    }
                                }
                                PsfParser.registerParser();
                                _this.capabilities.supportsCodecSwitching = _this.getSupportsCodecSwitching();
                                _this.capabilities.preconstructItems = preconstructItems;
                                _this.capabilities.preloadItems = preloadItems;
                                _this.capabilities.hasPrefetchSupport = preloadItems && hasPrefetchSupport;
                                _this.capabilities.preloadBufferTimeSecs = preloadBufferTimeSecs;
                                _ = _this.capabilities;
                                return [
                                    4,
                                    _this.capabilityHelper.getCompatibleStreamPropertyGroups(_this.device, _this.propositionHighFramerateValue)
                                ];
                            case 2:
                                _.compatibleStreamPropertyGroups = _state.sent();
                                _this.capabilities.supportsFullEvent = _this.getSupportsFullEvent();
                                return [
                                    4,
                                    getWidevineSecurity()
                                ];
                            case 3:
                                widevineSecurity = _state.sent();
                                _this.capabilities.widevineLevel = widevineSecurity.securityLevel;
                                _this.capabilities.widevineRobustness = widevineSecurity.robustnessLevel;
                                _this.capabilities.endOfStreamSeekTolerances = (_this_capabilityHelper_endOfStreamSeekTolerances = (_this_capabilityHelper2 = _this.capabilityHelper).endOfStreamSeekTolerances) === null || _this_capabilityHelper_endOfStreamSeekTolerances === void 0 ? void 0 : _this_capabilityHelper_endOfStreamSeekTolerances.call(_this_capabilityHelper2, _this.device);
                                Object.freeze(_this.capabilities);
                                versionCompliant = isVersionCompliant(_this.playerVersion, 'v41000');
                                if (versionCompliant && _this.isSafari && !_this.config.useMseOnSafari) {
                                    shaka.polyfill.PatchedMediaKeysApple.install(/* enableUninstall= */ true);
                                }
                                return [
                                    2,
                                    shaka.polyfill.installAll()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createPlayerEngine",
            value: function createPlayerEngine(playerEngineOptions) {
                return new ShakaPlayerEngine(this.config, playerEngineOptions, this.debugConfig, this.drmConfig, this.propositionThumbnailsConfig, this.createPlayerPrecursorEngine());
            }
        },
        {
            key: "canSupportCodec",
            value: function canSupportCodec(codec) {
                var _self_MediaSource;
                var _self_MediaSource_isTypeSupported;
                return (_self_MediaSource_isTypeSupported = (_self_MediaSource = self.MediaSource) === null || _self_MediaSource === void 0 ? void 0 : _self_MediaSource.isTypeSupported(codec)) !== null && _self_MediaSource_isTypeSupported !== void 0 ? _self_MediaSource_isTypeSupported : true;
            }
        },
        {
            key: "createPlayerPrecursorEngine",
            value: function createPlayerPrecursorEngine() {
                return new ShakaPlayerPrecursorEngine(this.config, this.capabilities, this.drmConfig, this.supportsPreload());
            }
        },
        {
            key: "getSupportedStreamingProtocols",
            value: function getSupportedStreamingProtocols() {
                return [
                    StreamingProtocol.HLS,
                    StreamingProtocol.DASH
                ];
            }
        },
        {
            key: "getSupportsCodecSwitching",
            value: function getSupportsCodecSwitching() {
                var _this_capabilityHelper_getCodecSwitchingSupport, _this_capabilityHelper;
                var supportsCodecSwitching = (_this_capabilityHelper_getCodecSwitchingSupport = (_this_capabilityHelper = this.capabilityHelper).getCodecSwitchingSupport) === null || _this_capabilityHelper_getCodecSwitchingSupport === void 0 ? void 0 : _this_capabilityHelper_getCodecSwitchingSupport.call(_this_capabilityHelper, this.device);
                if (supportsCodecSwitching === false) {
                    return false;
                }
                return isVersionCompliant(this.playerVersion, MINIMUM_VERSION_FOR_CODEC_SWITCHING);
            }
        },
        {
            key: "getSupportsFullEvent",
            value: function getSupportsFullEvent() {
                var _this_capabilityHelper_getLargeDvrWindowSupport, _this_capabilityHelper;
                var supportsFullEventWindow = (_this_capabilityHelper_getLargeDvrWindowSupport = (_this_capabilityHelper = this.capabilityHelper).getLargeDvrWindowSupport) === null || _this_capabilityHelper_getLargeDvrWindowSupport === void 0 ? void 0 : _this_capabilityHelper_getLargeDvrWindowSupport.call(_this_capabilityHelper, this.device);
                if (supportsFullEventWindow === false) {
                    return false;
                }
                return isVersionCompliant(this.playerVersion, MINIMUM_VERSION_FOR_FULL_EVENT);
            }
        },
        {
            key: "supportsPreload",
            value: function supportsPreload() {
                return 'preload' in shaka.Player.prototype && !(this.isSafari && !this.config.useMseOnSafari);
            }
        },
        {
            key: "setCapabilityHelper",
            value: function setCapabilityHelper() {
                var defaultCapabilityHelper = {
                    getCompatibleStreamPropertyGroups: function() {
                        return Promise.resolve([
                            {
                                maxFrameRate: Infinity,
                                maxVideoFormat: DEFAULT_VIDEO_FORMAT,
                                supportedColourSpaces: [
                                    VideoColourSpace.SDR
                                ]
                            }
                        ]);
                    },
                    getSupportedAudioFormats: function() {
                        return [
                            AudioFormat.STEREO
                        ];
                    }
                };
                var deviceCapabilityHelper = {};
                switch(this.device.type){
                    case DeviceType.Browser:
                        deviceCapabilityHelper = mseBrowserCapabilities;
                        break;
                    case DeviceType.WinUI2:
                        deviceCapabilityHelper = mseWinUI2Capabilities;
                        break;
                    case DeviceType.Tizen:
                        deviceCapabilityHelper = mseTizenCapabilities;
                        break;
                    case DeviceType.Vidaa:
                        deviceCapabilityHelper = mseVidaaCapabilities;
                        break;
                    case DeviceType.Vizio:
                        deviceCapabilityHelper = mseVizioCapabilities;
                        break;
                    case DeviceType.WebOS:
                        deviceCapabilityHelper = mseWebOsCapabilities;
                        break;
                    case DeviceType.Prospero:
                        deviceCapabilityHelper = mseProsperoCapabilities;
                        break;
                    case DeviceType.XboxOne:
                    case DeviceType.XboxSeries:
                        deviceCapabilityHelper = mseUwpCapabilities;
                        break;
                    case DeviceType.OneSdk:
                        deviceCapabilityHelper = mseOneSdkCapabilities;
                        break;
                    case DeviceType.MultiChoiceRdk:
                        deviceCapabilityHelper = mseMultiChoiceRdkCapabilities;
                        break;
                    case DeviceType.Quest:
                        deviceCapabilityHelper = mseQuestCapabilities;
                        break;
                    case DeviceType.Netgem:
                        deviceCapabilityHelper = mseNetgemCapabilities;
                        break;
                    case DeviceType.Zenterio:
                        deviceCapabilityHelper = mseZenterioCapabilities;
                        break;
                    case DeviceType.Kpn:
                        deviceCapabilityHelper = mseKpnCapabilities;
                        break;
                    case DeviceType.Kepler:
                        deviceCapabilityHelper = mseKeplerCapabilities;
                        break;
                    default:
                        break;
                }
                this.capabilityHelper = _object_spread({}, defaultCapabilityHelper, deviceCapabilityHelper);
            }
        }
    ]);
    return ShakaPlayerEngineFactory;
}();

//# sourceMappingURL=shaka-player-engine-factory.js.map